import React, { useEffect } from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { WorldInterface, setEditId, setEditError, selectWorldById } from "../../../store/mine_craft/worldsSlice";
import { updateWorld, fetchWorld } from "../../../actions/mine_craft/worldsActions";
import { objToFormData } from "../../../helpers/FormHelper";
import { fetchCategories } from "../../../actions/mine_craft/categoriesActions";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";
import {queryParams} from "../../../helpers/UrlHelpers";

const TARGET_ID = 2;

const Edit = () => {
  const navigate        = useNavigate();
  const dispatch        = useAppDispatch();
  const location        = useLocation();
  const [searchParams]  = useSearchParams();
  const categoryId      = queryParams.getInt(searchParams,'category_id');
  const id: any         = useAppSelector(state => state.mineCraft.worlds.editId);
  const error           = useAppSelector(state => state.mineCraft.worlds.editError);
  const world           = useAppSelector(state => id ? selectWorldById(state, id) : undefined);

  useEffect(() => {
    if (id) {
      dispatch(fetchCategories({ target_id: TARGET_ID }));
      dispatch(fetchWorld(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    dispatch(setEditId(null));
  }, [location, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: WorldInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: WorldInterface) {
    const formData: any = objToFormData(data);
    const resultAction = await dispatch(updateWorld({ id, data: formData }));

    if (updateWorld.fulfilled.match(resultAction)) {
      onClose();

      if (!data.category_ids.includes(categoryId || 0)) {
        navigate(0);
      }
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-world'>
        <h6 className="v-content-label">Edit Map</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <Form params={world} onFinish={onFinish} />
      </div>
    </DrawerRight>
  )
}

export default Edit;
